import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { FadeIn } from './ui/FadeIn';
export function OfferSection() {
  return <section id="offer" className="bg-white py-24 px-4" data-id="element-112">
      <div className="max-w-5xl mx-auto" data-id="element-113">
        <FadeIn data-id="element-114">
          <div className="bg-beige rounded-[3rem] p-8 md:p-12 lg:p-16 shadow-xl relative overflow-hidden" data-id="element-115">
            {/* Decorative background elements */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-white rounded-full mix-blend-overlay filter blur-3xl opacity-40 transform translate-x-1/2 -translate-y-1/2" data-id="element-116"></div>
            <div className="absolute bottom-0 left-0 w-64 h-64 bg-terracotta rounded-full mix-blend-overlay filter blur-3xl opacity-10 transform -translate-x-1/2 translate-y-1/2" data-id="element-117"></div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center relative z-10" data-id="element-118">
              <div data-id="element-119">
                <h2 className="text-3xl md:text-4xl font-bold text-brown-dark mb-6" data-id="element-120">
                  Tu transformación comienza hoy
                </h2>
                <p className="text-xl text-brown-body mb-8" data-id="element-121">
                  Hoy puedes acceder al{' '}
                  <strong className="text-brown-dark" data-id="element-122">
                    Protocolo Anti-Inflamación 72h
                  </strong>{' '}
                  completo, incluyendo la guía, las checklists y el bono de
                  mantenimiento, por un pago único.
                </p>

                <div className="bg-white/60 backdrop-blur-sm p-6 rounded-2xl mb-8 border border-white" data-id="element-123">
                  <p className="text-lg text-brown-dark font-medium mb-2" data-id="element-124">
                    Recupera el control de tu cuerpo por menos de lo que cuesta
                    una cena fuera de casa.
                  </p>
                  <div className="text-terracotta font-bold text-3xl md:text-4xl mt-4 font-heading" data-id="element-125">
                    Precio Especial: $8.39 USD
                  </div>
                </div>

                <Button fullWidth className="mb-4 shadow-xl" onClick={() => window.open('https://sd-store-9858.myshopify.com//cart/52982862217579:1', '_blank')} data-id="element-126">
                  ¡QUIERO DESINFLAMARME AHORA!
                </Button>

                <div className="flex items-center justify-center space-x-2 text-sm text-brown-body mt-4" data-id="element-127">
                  <ShieldCheckIcon className="w-5 h-5 text-sage" data-id="element-128" />
                  <span data-id="element-129">
                    Acceso instantáneo en formato PDF tras la compra. Pago 100%
                    seguro.
                  </span>
                </div>
              </div>

              <div className="flex justify-center lg:justify-end" data-id="element-130"></div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}